import { Col, Row } from "antd";
import { SubmitButton, TextComponent } from "../../../../../../components";
import styles from "./LinkGuest.module.css";
import { showAlert } from "../../../../../../Store/Actions/GeneralActions";
import { useDispatch } from "react-redux";
import { useState } from "react";

const points = [
  { text: "Send your link to family and friends." },
  { text: "Guests fill out their details" } 
];

const LinkGuest = () => {
  const [isCopied, setIsCopied] = useState(false);
  const dispatch = useDispatch();

  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard("https://bestdayever-web.web.app")
      .then(() => {
        dispatch(showAlert({
          type: "Success",
          message: "Copied"
        }))
        // If successful, update the isCopied state value
        setIsCopied(true);
        // setIsCopyModalOpen(false)
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Row className={styles.mainRow}>
      <Row className={styles.firstRow}>
        <Col xs={24}>
          <TextComponent textClass={styles.firstRowText}>
           Share application link with your guests.
          </TextComponent>
        </Col>
      </Row>
      <Row className={styles.secondRow}>
        <Col xs={24}>
          {points.map((point, i) => (
            <TextComponent textClass={styles.point}>
              {i + 1}.&nbsp;{point.text}
            </TextComponent>
          ))}
        </Col>
      </Row>
      <Row className={styles.btnRow}>
        {/* <Col xs={4}>
          <SubmitButton title="Select File" outline={true} />
        </Col>
        <Col xs={4}>
          <SubmitButton title="Continue" />
        </Col> */}
        <Col
          xs={24}
          sm={22}
          md={20}
          lg={16}
          xl={12}
          className={styles.inputCol}
        >
          {/* <Row>
            <Col xs={24} sm={18}> */}
          <div className={styles.input}>
            <input
            disabled={true}
              className={styles.inner_input}
              
              placeholder="https://bestdayever-web.web.app"
            />
            
          </div>
          {/* </Col>
            <Col xs={24} sm={6}> */}
          <SubmitButton title="Copy Link" btnClass={styles.copyBtn} onClick={handleCopyClick} />
          {/* </Col> */}
          {/* </Row> */}
        </Col>
      </Row>
    </Row>
  );
};

export default LinkGuest;
